import { Component, OnInit } from '@angular/core';
import { NgWizardService } from 'ng-wizard';
import { CrmService } from 'app/services/crm.service';
import { RemoteAssessment } from 'app/model/remote-assessment';
import { ContextService } from 'app/services/context.service';
import { ToastService } from 'app/services/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-finish',
  templateUrl: './finish.component.html',
  styleUrls: ['./finish.component.css']
})
export class FinishComponent implements OnInit {
  remoteAssessment: RemoteAssessment;
  isEosCancelledNoOutOfLevel = false;

  constructor(private ngWizardService: NgWizardService, private crmService: CrmService,
    private context: ContextService, public toastService: ToastService, private router: Router) { }

  ngOnInit(): void {
    this.context.remoteAssessment.subscribe(ra => {
      this.remoteAssessment = ra;
      this.isEosCancelledNoOutOfLevel = this.getIsEosCancelledNoOutOfLevel();
    });

  }

  private getEosCancelledNoOutOfLevelKey(): string {
    const assessmentId = this.remoteAssessment?.assessment?.id || '';
    return `EOS_CANCELLED_NO_OUT_OF_LEVEL_${assessmentId}`;
  }

  private getIsEosCancelledNoOutOfLevel(): boolean {
    const isEos = String(this.remoteAssessment?.assessment?.assessmentType?.id || '') === '806390002';
    if (!isEos) {
      return false;
    }

    const isLocked = this.remoteAssessment?.assessment?.isPSDLocked === true;
    if (!isLocked) {
      return false;
    }

    const key = this.getEosCancelledNoOutOfLevelKey();
    return sessionStorage.getItem(key) === 'true' || localStorage.getItem(key) === 'true';
  }

  submit() {
    if (this.isEosCancelledNoOutOfLevel) {
      return;
    }

    if (this.remoteAssessment.remoteAnswer.filter(a => a.hasFiles).length > 0){
      this.crmService.SubmitAssessment(this.remoteAssessment.assessment.id).subscribe(r => {
        if (r.result) {
          // PSD15_EOS_REQUIRED is set in Step 2 (confirm-selection) before any state mutation.
          // finish.component.ts must not recompute it here as ps.selected may already be cleaned up.
          this.router.navigate(['/submitted']);
          this.toastService.showSuccess('Submitted Successfully')
        }
        else{
        
            this.toastService.showDanger(r.message);
          
        }
      })
    }else{
      this.toastService.showDanger('You need to have at least one document uploaded before submitting');
    }
    
  }
  previousStep() {
    if (this.isEosCancelledNoOutOfLevel) {
      return;
    }

    this.ngWizardService.previous();
  }
}
